<template>
  <b-row>
    <b-col>
      <h5>{{ $t('orders.payee') }}</h5>
      <div v-if="order.user">
        {{ order.user.name }}
      </div>
      <div v-else>
        <system-user />
      </div>
    </b-col>
    <b-col>
      <h5>{{ $t('orders.recipient') }}</h5>
      <div v-if="order.recipient">
        {{ order.recipient.name }}
      </div>
      <div v-else>
        <system-user />
      </div>
    </b-col>
  </b-row>
</template>

<script>
import SystemUser from '../components/SystemUser'

export default {
  name: 'OrderSides',

  components: {
    SystemUser,
  },

  props: {
    order: { type: Object, required: true },
  },
}
</script>
